/** @returns {number} Idle lock timeout in milliseconds */
export function getSessionTimeoutMs() {
  const minutes = Number(import.meta.env.VITE_SESSION_TIMEOUT_MINUTES ?? 15)
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return 15 * 60 * 1000
  }
  return minutes * 60 * 1000
}

/** Activity events that reset the idle timer */
export const SESSION_ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart',
  'click',
]
